import {
  setEvaluationResults,
  starOfTheMonthEmployee,
} from "./employeeEvaluation.types";

const INITIAL_STATE = {
  evaluationResults: {
    great: 0,
    good: 0,
    avg: 0,
    fair: 0,
    poor: 0,
  },
  starOfTheMonth: [],
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case setEvaluationResults:
      return {
        ...state,
        evaluationResults: action.payload,
      };

    case starOfTheMonthEmployee:
      return {
        ...state,
        starOfTheMonth: action.payload,
      };

    default:
      return state;
  }
};

export default reducer;
